<template>
    <div class="sustainable-component wage-evaluate-basework" data-testid="wage-evaluate-basework-root">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-evaluate-basework</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-4">Arbetsuppgifter</th>
                                <th class="col-8">Utbildning/krav</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in jobPositionBlocks" :key="index">
                                <td>
                                    <span v-html="item.Name"></span>
                                </td>
                                <td>
                                    <span  v-html="item.EducationAndRequirements"></span>
                                </td>
                                <!--
                            <td class="col-1">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>-->
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="col-12 col-md-6">
                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-3">Faktornr.</th>
                                <th class="col-6">Faktornamn</th>
                                <th class="col-3">Gradnr.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in jobPositionBlockFactorGrades" :key="index">
                                <td>
                                    <span>{{item.BaseFactorNumber}}</span>
                                </td>
                                <td>
                                    <span>{{item.BaseFactorName}}</span>
                                </td>
                                <td>
                                    <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" hide-details density="compact" label="Gradnr." :items="item.Grades" v-model="item.GradeNumber" item-title="GradeNumber" item-value="GradeNumber" @update:modelValue="changedValue(item)"></v-select>
                                </td>
                                <!--
                            <td class="col-1">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>-->
                            </tr>
                            <tr>
                                <td colspan="3"><b>Summa poäng: {{totalPoints}}</b></td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import WageService from "../../Services/WageService";
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'wage-evaluate-basework',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async loadTasks(newPosition) {
                this.loading++;
                try {
                    var tmp = await WorkOrganisationService.getJobPositionBaseBlockWorkTasks(newPosition);
                    this.jobPositionBlocks = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadFactors(newPosition) {
                this.loading++;
                try {
                    this.jobPositionBlockFactorGrades = await WageService.getPositionBaseFactorGradesWithGrades(newPosition);
                    this.getTotalPoints(newPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            
            loadValues(newPosition) {
                this.loading++;
                try {
                    this.loadTasks(newPosition);
                    this.loadFactors(newPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getFactorGrades(baseFactorId) {
                return this.jobPositionBlockFactorGrades.filter((item) => item.BaseFactorId != baseFactorId);
            },
            async changedValue(item) {
                this.loading++;
                try {
                    await WageService.updateJobPositionBaseFactorGrade(this.selectedPosition, item.BaseFactorId, item.GradeNumber)
                    this.displaySnackBar("Sparat");
                    this.loadFactors(this.selectedPosition)
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async getTotalPoints(newPosition) {
                this.loading++;
                try {
                    this.totalPoints = await WageService.getPositionTotalBasePoints(newPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },

        },
        data() {
            return {
                totalPoints:0,
                jobPositionBlocks: [],
                jobPositionBlockFactorGrades: [],
                jobbaseFactorGrades: [],
                selectedPosition:null,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
             selectedPosition: function (newPosition) {
                this.loadValues(newPosition);
                this.$emit('positionSelected', newPosition)
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            if (this.internalModel.JobPositions.length > 0 && this.selectedJobPosition == null) {
                this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            }
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
